/**
 * Активная строка всплывающего списка учеников: куда она едет по стрелке
 * (выбор получателей, 5.4 docs/homework-phase2-design.md).
 *
 * Вынесено из `StudentPicker.tsx` чистой функцией, потому что ошибка здесь
 * тихая: стрелка, остановившаяся на отвязанном, превращает Enter в нажатие,
 * которое ничего не делает, а человек, выбирающий с клавиатуры, решит, что
 * ученик отмечен.
 *
 * Строки описаны одним признаком «выключена» по индексу: списку отвязанные
 * ПОКАЗАНЫ (прятать нельзя, их отсутствие читается как удаление), а стрелка их
 * перешагивает. Значение `-1` означает «активной строки нет»: список только
 * раскрылся или поиск его перестроил.
 *
 * ⚠️ У краёв стрелка останавливается, а не уходит на другой конец. Список
 * отсортирован по свежести занятий, и прыжок с последнего ученика на первого
 * при лишнем нажатии выглядит как «список перемешался».
 */

/** Индекс активной строки, годный для этого списка, или `-1`. */
export function validActive(disabled: readonly boolean[], current: number): number {
  if (current < 0 || current >= disabled.length) return -1;
  return disabled[current] === true ? -1 : current;
}

/**
 * Следующая выбираемая строка в направлении `dir`.
 *
 * Без активной строки вниз значит «первая выбираемая», вверх значит
 * «последняя». Дальше края не едет: там возвращается текущая. Выбираемых нет
 * вовсе значит `-1`.
 */
export function stepActive(disabled: readonly boolean[], current: number, dir: 1 | -1): number {
  const from = validActive(disabled, current);
  let i = from === -1 ? (dir === 1 ? -1 : disabled.length) : from;
  for (i += dir; i >= 0 && i < disabled.length; i += dir) {
    if (disabled[i] !== true) return i;
  }
  return from;
}
